import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-mall-synergy",
  "use": "icon-soc-l1-mall-synergy-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-mall-synergy\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M320 288a96 96 0 1 1 0 192 96 96 0 0 1 0-192zm384 0a96 96 0 1 1 0 192 96 96 0 0 1 0-192zM512 544a96 96 0 1 1 0 192 96 96 0 0 1 0-192z\" />\r\n  <path d=\"M400 392h64v24h-64v-24zm160 0h64v24h-64v-24zM464 480h96v24h-96v-24z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-mall-synergy.svg
// module id = plS9
// module chunks = 492